import { Checkbox, MenuItem, Typography } from '@mui/material';

import { styles } from './MutliSelect.styles';
import type { TMultiSelectItemProps } from './types';

export const MultiSelectItem = ({ item, selected, toggle }: TMultiSelectItemProps) => {
  return (
    <MenuItem onClick={toggle} sx={styles.item}>
      <Checkbox sx={styles.itemCheckbox} checked={selected} />

      <Typography fontWeight={500} noWrap>
        {item.title}
      </Typography>

      <Typography variant="caption" color="text.disabled" noWrap>
        {item.details}
      </Typography>
    </MenuItem>
  );
};
